import {base} from './base';

export const charcoal = base
  .extend('charcoal')
  // Colors
  .property('primary.color', '#5D6A7A')
  .property('primary.font', 'Poiret One')

  // border radius
  .property('border.radius', '0px')

  // Page
  .property('page.background.color', '#FFFFFF')

  // Text
  .property('text.font', 'Acumin Pro')
  .property('text.color', '#0A1B2D')

  // Menu
  .property('menu.background.color', '#0A1B2D')
  .property('menu.text.font', 'Poiret One')
  .property('menu.text.color', '#EDEFF2')

  // Image
  .property(
    'image.default',
    'https://images.teemill.com/og6ut5ahtodxyrqvfd4hddtizx4si4qsirth6pqgrwosr392.png'
  )

  // Banners
  .property('banner.title.color', '#EDEFF2')
  .property('banner.copy.color', '#EDEFF2')

  // Features
  .property('feature.text.color', '#0A1B2D')

  // Quote
  .property('quote.text.color', '#EDEFF2')
  .property('quote.fullBackground.color', '#323E49')

  // AnnouncementV2
  .property('announcement.v2.text.color', '#EDEFF2')
  .property('announcement.v2.background.color', '#636363')

  // Newsletter
  .property('newsletter.text.color', '#EDEFF2')
  .property('newsletter.fullBackground.color', '#5D6A7A')

  // Footer
  .property('footer.text.color', '#EDEFF2')
  .property('footer.background.color', '#0A1B2D');
